export const Globals = {
	validateInteger: (value) => {
		return /^\d+$/.test(value);
	}
}